import { CellUtil, ComponentData, TabUtil } from '@ddt-web/data-service';
import * as get from 'lodash/get';
import * as isNil from 'lodash/isNil';

export class PerformanceVisibilityUtil {

	public static isPerformanceComponentDataVisible(componentData: ComponentData, isCustomFeeEnabled: boolean, customAdvisoryFee: number) {
		// Tables
		const hypoGrossPerfTableTabData = componentData && TabUtil.getVisibleTabData(componentData.getTabById('hypo-performance'));
		const hypoNetCustomPerfTableTabData = componentData && TabUtil.getVisibleTabData(componentData.getTabById('hypo-net-custom-performance'));

		// gross validity check
		const isHypoGrossPerfValidData = CellUtil.isValidCellData(hypoGrossPerfTableTabData) && get(hypoGrossPerfTableTabData, 'displayConfig.visible', false);
		const hypoGrossPerfTabHasError = hypoGrossPerfTableTabData && !isHypoGrossPerfValidData;

		// net custom validity check
		const isHypoNetCustomPerfValidData = CellUtil.isValidCellData(hypoNetCustomPerfTableTabData) && get(hypoNetCustomPerfTableTabData, 'displayConfig.visible', false);
		const hypoNetCustomPerfTabHasError = hypoNetCustomPerfTableTabData && !isHypoNetCustomPerfValidData;

		const performanceData = hypoGrossPerfTableTabData || hypoNetCustomPerfTableTabData;

		const shouldShowHypotheticalPerformance = isCustomFeeEnabled && customAdvisoryFee ?
			!isNil(performanceData) && !hypoGrossPerfTabHasError && !hypoNetCustomPerfTabHasError : !isNil(performanceData) && !hypoGrossPerfTabHasError;

		return componentData && componentData.success && shouldShowHypotheticalPerformance;
	}
}
